import React, { useState, useEffect, useRef, useCallback } from "react";
import { __ } from "@wordpress/i18n";
import FeedCTA from "./cta";
import { getBlockById, buildCustomizerUrl, primaryButtonStyle } from './utils';

const FeedPreview = (props) => {
    const {
        blockId,
        feedId,
        ajaxUrl,
        ajaxAction,
        nonce,
        initCallback,
        onFeedChange,
        feeds,
        feedsOptions,
        createFeedUrl,
        isPro,
    } = props;

    const [html, setHtml] = useState('');
    const [loading, setLoading] = useState(false);
    const containerRef = useRef(null);
    const block = getBlockById(blockId);

    const fetchFeed = useCallback(() => {
        if (!feedId || !ajaxUrl || !ajaxAction) return;

        setLoading(true);

        const formData = new FormData();
        formData.append('action', ajaxAction);
        formData.append('feed_id', feedId);
        if (nonce) {
            formData.append('nonce', nonce);
        }

        fetch(ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((res) => res.text())
            .then((data) => {
                setHtml(data);
                setLoading(false);
            })
            .catch(() => {
                setHtml('');
                setLoading(false);
            });
    }, [feedId, ajaxUrl, ajaxAction, nonce]);

    useEffect(() => {
        fetchFeed();
    }, [fetchFeed]);

    useEffect(() => {
        if (html && containerRef.current && typeof initCallback === 'function') {
            initCallback(containerRef.current);
        }
    }, [html, initCallback]);

    if (!feedId) {
        return (
            <FeedCTA
                id={blockId}
                feeds={feeds}
                feedsOptions={feedsOptions}
                createFeedUrl={createFeedUrl}
                isPro={isPro}
                attributes={{ feedId }}
                setAttributes={({ feedId: newFeedId }) => {
                    if (typeof onFeedChange === 'function') {
                        onFeedChange(newFeedId);
                    }
                }}
            />
        );
    }

    const customizerUrl = block?.customizerPage
        ? buildCustomizerUrl(block.customizerPage, feedId)
        : null;

    return (
        <div className="sbc-feed-blocks-preview-wrap">
            {loading && (
                <div className="sbc-feed-blocks-preview-loading">
                    <span>{__('Loading feed...', 'sb-common')}</span>
                </div>
            )}
            <div
                ref={containerRef}
                className="sbc-feed-blocks-preview-content"
                dangerouslySetInnerHTML={{ __html: html }}
            />
        </div>
    );
};

export default FeedPreview;
